"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setClassesId = exports.appWillUnmount = exports.appWillLoad = void 0;
const actionTypes_1 = require("./actionTypes");
const appWillLoad = () => {
    return {
        type: actionTypes_1.APP_WILL_LOAD,
    };
};
exports.appWillLoad = appWillLoad;
const appWillUnmount = () => {
    return {
        type: actionTypes_1.APP_WILL_UNMOUNT,
    };
};
exports.appWillUnmount = appWillUnmount;
const setClassesId = () => {
    return {
        type: actionTypes_1.SET_CHANGE_CLASSES,
    };
};
exports.setClassesId = setClassesId;
